import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React, { Component } from 'react';
import Chart from 'chart.js';
import moment from 'moment';
import { Card, Grid, Box, Typography, Link as MuiLink, withStyles, CircularProgress } from '@material-ui/core';
import { ModuleTypeEnum, PluginManager, Logger, getIcon, ProfileManager } from '@kailona/core';
import TimeRangeFilter from './TimeRangeFilter';
import DateRangeEnum from '@kailona/core/src/enums/DateRange.enum';
import { withMain } from '../../context/MainContext';
var logger = new Logger('main.Timeline');
var Link = withStyles(function (theme) {
  return {
    root: {
      margin: '0 10px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      opacity: 0.7,
      '&.active': {
        opacity: 1
      },
      '&:hover': {
        textDecoration: 'none'
      },
      '& > .plugin-name': {
        fontSize: '12px'
      },
      '& > .plugin-name, & > .plugin-icon': {
        color: theme.palette.gray40.main
      },
      '&.disabled': {
        pointerEvents: 'none',
        color: theme.palette.gray30.main,
        '& .plugin-name': {
          color: theme.palette.gray30.main
        }
      }
    }
  };
})(MuiLink);

var Timeline = /*#__PURE__*/function (_Component) {
  _inherits(Timeline, _Component);

  var _super = _createSuper(Timeline);

  function Timeline(props) {
    var _this;

    _classCallCheck(this, Timeline);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "repositionPointsOnTheSameLabel", function (chart) {
      chart.config.data.datasets.forEach(function (dataset, datasetIndex) {
        var data = dataset.data;
        var metaKey = Object.keys(dataset._meta)[0]; // Set index of data points

        data.forEach(function (dt, index) {
          return dt.index = index;
        }); // Group data by x value

        var result = data.reduce(function (r, a) {
          r[a.x] = r[a.x] || [];
          r[a.x].push(a);
          return r;
        }, Object.create(null));
        Object.keys(result).forEach(function (key) {
          var dataByKey = result[key];
          var centerIndex = dataByKey.length >= 3 ? Math.ceil(dataByKey.length / 3) : 0;
          var centerData = dataByKey[centerIndex];
          var positionOfLatest = chart.config.data.datasets[datasetIndex]._meta[metaKey].data[centerData.index]._model.x;

          if (dataByKey.length <= 1) {
            return;
          } // Sort group data as descending


          var pointRadius = _this.state.dynamicPointRadius || 0;
          dataByKey.forEach(function (dt, index) {
            var dtIndex = dt.index; // Skip repositioning the latest point

            if (index < centerIndex) {
              chart.config.data.datasets[datasetIndex]._meta[metaKey].data[dtIndex]._model.x = positionOfLatest - pointRadius;
            } else if (index > centerIndex) {
              chart.config.data.datasets[datasetIndex]._meta[metaKey].data[dtIndex]._model.x = positionOfLatest + pointRadius;
            }
          });
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getDataButtonColor", function (timelineDataName) {
      if (!_this.state.activeDataNames.includes(timelineDataName) || !_this.state.completedPlugins.includes(timelineDataName)) {
        return '#999999';
      }

      return _this.timelineModules.find(function (item) {
        return item.name === timelineDataName;
      }).color;
    });

    _defineProperty(_assertThisInitialized(_this), "handleDateRangeChange", function (dateRangeEnumValue) {
      _this.setState({
        selectedDateRange: dateRangeEnumValue
      }, function () {
        _this.fetchChartData();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getChartData", function (existingChartData, xLabels, name, color, mappedData) {
      // Do not get this.state here since it is a lazy loading function
      // Keep the existing datasets
      var chartData = Object.assign({}, {
        datasets: []
      }, existingChartData || {}); // Use the new xLabels

      chartData.labels = xLabels; // Resize data points dynamically

      var slotWidth = _this.state.slotWidth;
      var slotHalfWidth = slotWidth / 2;
      var maxPointsOnSameLabel = 4;
      var minSize = 2;
      var size = Math.max(slotHalfWidth / maxPointsOnSameLabel);
      var dynamicPointRadius = size < minSize ? minSize : size;

      _this.setState({
        dynamicPointRadius: dynamicPointRadius
      });

      var dataSet = {
        label: name,
        data: mappedData,
        fill: false,
        backgroundColor: color,
        borderColor: color,
        yAxisID: "yAxis".concat(name.replace(/\s/g, '')),
        lineTension: 0,
        showLine: false,
        pointStyle: 'line',
        pointBorderWidth: 3,
        pointRadius: dynamicPointRadius,
        pointHoverRadius: dynamicPointRadius + 2,
        pointHoverBorderWidth: 4,
        pointBackgroundColor: color
      };
      var found = false;

      for (var i = 0; i < chartData.datasets.length; i++) {
        if (chartData.datasets[i].label !== name) {
          continue;
        }

        found = true;
        chartData.datasets[i] = dataSet;
      }

      if (!found) {
        chartData.datasets.push(dataSet);
      }

      return chartData;
    });

    _defineProperty(_assertThisInitialized(_this), "getChartOptions", function (existingChartOptions, name, mappedData) {
      // Do not get this.state here since it is a lazy loading function
      var chartOptions = Object.assign({}, existingChartOptions || {
        responsive: true,
        aspectRatio: 4,
        legend: {
          display: false
        },
        layout: {
          padding: {
            top: 5
          }
        },
        tooltips: {
          callbacks: {
            title: function title(tooltipItems, data) {
              return data.datasets[tooltipItems[0].datasetIndex].data[tooltipItems[0].index].x;
            }
          }
        },
        scales: {
          yAxes: []
        }
      });
      var min = 0;
      var max = 10;

      if (mappedData && mappedData.length) {
        min = mappedData[0].y;
        max = mappedData[0].y;
        mappedData.forEach(function (_ref) {
          var y = _ref.y;

          if (y < min) {
            min = y;
          }

          if (y > max) {
            max = y;
          }
        });
      }

      var stepSize = Math.round((max - min) / 10);
      var yAxis = {
        id: "yAxis".concat(name.replace(/\s/g, '')),
        display: false,
        ticks: {
          beginAtZero: true,
          stepSize: stepSize,
          max: max + stepSize // add some space on top

        },
        gridLines: {
          drawOnArea: false
        }
      };
      var found = false;

      for (var i = 0; i < chartOptions.scales.yAxes.length; i++) {
        if (chartOptions.scales.yAxes[i].label !== name) {
          continue;
        }

        found = true;
        chartOptions.scales.yAxes[i] = yAxis;
      }

      if (!found) {
        chartOptions.scales.yAxes.push(yAxis);
      }

      return chartOptions;
    });

    _defineProperty(_assertThisInitialized(_this), "mapTimelineData", function (data, isYearDifferent) {
      var mappedData = [];
      data.forEach(function (dataItem) {
        var date = dataItem.date,
            value = dataItem.value,
            values = dataItem.values;

        var x = _this.getXValue(date, isYearDifferent);

        if (value) {
          mappedData.push({
            x: x,
            y: value
          });
        } else if (values && values.length) {
          mappedData.push(values.map(function (v) {
            return {
              x: x,
              y: v
            };
          }));
        }
      });
      return mappedData;
    });

    _defineProperty(_assertThisInitialized(_this), "getXValue", function (date, isYearDifferent) {
      if (isYearDifferent) {
        return moment(date).format("MMM DD, YYYY");
      }

      return moment(date).format("MMM DD");
    });

    _defineProperty(_assertThisInitialized(_this), "getDateRangeValues", function () {
      var selectedDateRange = _this.state.selectedDateRange;

      if (selectedDateRange === DateRangeEnum.ONE_MONTH) {
        return {
          dateStart: moment().subtract(1, 'month'),
          dateEnd: moment()
        };
      }

      if (selectedDateRange === DateRangeEnum.THREE_MONTH) {
        return {
          dateStart: moment().subtract(3, 'month'),
          dateEnd: moment()
        };
      }

      if (selectedDateRange === DateRangeEnum.SIX_MONTH) {
        return {
          dateStart: moment().subtract(6, 'month'),
          dateEnd: moment()
        };
      }

      if (selectedDateRange === DateRangeEnum.NINE_MONTH) {
        return {
          dateStart: moment().subtract(9, 'month'),
          dateEnd: moment()
        };
      }

      if (selectedDateRange === DateRangeEnum.ONE_YEAR) {
        return {
          dateStart: moment().subtract(1, 'year'),
          dateEnd: moment()
        };
      }

      if (selectedDateRange === DateRangeEnum.TWO_YEAR) {
        return {
          dateStart: moment().subtract(2, 'year'),
          dateEnd: moment()
        };
      } // MAX (All Lifetime)


      var patientDob = ProfileManager.activeProfile.patientDob;

      if (patientDob) {
        return {
          dateStart: moment(patientDob),
          dateEnd: moment()
        };
      } // Revert back to 1M


      return {
        dateStart: moment().subtract(1, 'month'),
        dateEnd: moment()
      };
    });

    _defineProperty(_assertThisInitialized(_this), "getXLabels", function (dateStart, dateEnd, isYearDifferent) {
      var xLabels = [];

      for (var date = dateStart.clone(); date.isSameOrBefore(dateEnd); date.add(1, 'day')) {
        xLabels.push(_this.getXValue(date, isYearDifferent));
      }

      return xLabels;
    });

    _defineProperty(_assertThisInitialized(_this), "loadChart", function (currentState, xLabels, dataSetList) {
      var existingChartData = currentState.chartData && Object.assign({}, currentState.chartData);
      var existingChartOptions = currentState.chartOptions && Object.assign({}, currentState.chartOptions);
      var allMappedDataInGroup = [];
      dataSetList.forEach(function (_ref2) {
        var name = _ref2.name,
            color = _ref2.color,
            mappedData = _ref2.mappedData;
        allMappedDataInGroup.push.apply(allMappedDataInGroup, _toConsumableArray(mappedData));

        var chartData = _this.getChartData(existingChartData, xLabels, name, color, mappedData);

        var chartOptions = _this.getChartOptions(existingChartOptions, name, allMappedDataInGroup);

        existingChartData = chartData && Object.assign({}, chartData);
        existingChartOptions = chartOptions && Object.assign({}, chartOptions);
      });
      return {
        chartData: existingChartData,
        chartOptions: existingChartOptions
      };
    });

    _defineProperty(_assertThisInitialized(_this), "fetchChartData", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _this$getDateRangeVal, dateStart, dateEnd, isYearDifferent, completedPlugins, xLabels;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this$getDateRangeVal = _this.getDateRangeValues(), dateStart = _this$getDateRangeVal.dateStart, dateEnd = _this$getDateRangeVal.dateEnd;
              isYearDifferent = dateStart.year() !== dateEnd.year();
              completedPlugins = [];

              _this.setState({
                completedPlugins: completedPlugins
              });

              xLabels = _this.getXLabels(dateStart, dateEnd, isYearDifferent);

              _this.setSlotWidth(xLabels.length);

              _this.timelineModules.forEach( /*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(timelineModule) {
                  var name, color, getData, children, dataSetList, data, mappedData, promises, promiseResults;
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          name = timelineModule.name, color = timelineModule.color, getData = timelineModule.getData, children = timelineModule.children; // Fetch data using timeline data function(s)

                          dataSetList = [];

                          if (!(typeof getData === 'function')) {
                            _context.next = 10;
                            break;
                          }

                          _context.next = 5;
                          return getData(dateStart, dateEnd);

                        case 5:
                          data = _context.sent;
                          mappedData = _this.mapTimelineData(data, isYearDifferent);
                          dataSetList.push({
                            name: name,
                            color: color,
                            mappedData: mappedData
                          });
                          _context.next = 20;
                          break;

                        case 10:
                          if (!children) {
                            _context.next = 19;
                            break;
                          }

                          promises = [];
                          children.forEach(function (child) {
                            var promise = new Promise(function (resolve) {
                              child.getData(dateStart, dateEnd).then(function (data) {
                                var mappedData = _this.mapTimelineData(data, isYearDifferent);

                                resolve({
                                  name: child.name,
                                  color: child.color || color,
                                  mappedData: mappedData
                                });
                              });
                            });
                            promises.push(promise);
                          });
                          _context.next = 15;
                          return Promise.all(promises);

                        case 15:
                          promiseResults = _context.sent;
                          dataSetList.push.apply(dataSetList, _toConsumableArray(promiseResults));
                          _context.next = 20;
                          break;

                        case 19:
                          return _context.abrupt("return");

                        case 20:
                          // Prevent race condition with react state since this is lazy loading for multiple timeline data
                          completedPlugins.push(name);

                          _this.setState(function (currentState) {
                            var _this$loadChart = _this.loadChart(currentState, xLabels, dataSetList),
                                chartData = _this$loadChart.chartData,
                                chartOptions = _this$loadChart.chartOptions; // Destroy the previous chart


                            if (currentState.chart) {
                              currentState.chart.destroy();
                            }

                            var chart = new Chart(_this.chartRef.current, {
                              type: 'line',
                              data: Object.assign({}, chartData),
                              options: Object.assign({}, chartOptions)
                            }); // Show only active ones after date range change

                            chart.data.datasets = _this.filterVisibleDatasets(chartData);
                            chart.update();
                            return {
                              chartData: chartData,
                              chartOptions: chartOptions,
                              chart: chart,
                              completedPlugins: completedPlugins
                            };
                          });

                        case 22:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x) {
                  return _ref4.apply(this, arguments);
                };
              }());

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));

    _defineProperty(_assertThisInitialized(_this), "setSlotWidth", function (labelsCount) {
      var margin = 70;
      var chartBoxWidth = _this.chartBoxRef.current.clientWidth - margin;
      var slotWidth = chartBoxWidth / labelsCount;

      _this.setState({
        slotWidth: slotWidth
      });
    });

    _this.timelineModules = [];
    _this.chartRef = /*#__PURE__*/React.createRef();
    _this.chartBoxRef = /*#__PURE__*/React.createRef();
    _this.state = {
      activeDataNames: [],
      selectedDateRange: DateRangeEnum.ONE_MONTH,
      slotWidth: 30,
      completedPlugins: [],
      userId: _this.props.userId
    };
    Chart.pluginService.register({
      beforeDatasetsDraw: function beforeDatasetsDraw(chart) {
        if (!chart || !chart.config) {
          return;
        }

        if (!chart.config.data || !chart.config.data.datasets || !chart.config.data.datasets.length) {
          return;
        }

        if (!chart.config.data.datasets[0]._meta) {
          return;
        }

        _this.repositionPointsOnTheSameLabel(chart);
      }
    });
    return _this;
  }

  _createClass(Timeline, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.userId === nextProps.userId) {
        this.fetchChartData();
        return;
      }

      var chart = this.state.chart;

      if (chart) {
        chart.destroy();
      } // Destroy and reinitialize the chart with new profile info


      this.setState({
        selectedDateRange: DateRangeEnum.ONE_MONTH,
        userId: nextProps.userId,
        chart: chart,
        chartData: []
      });
      this.fetchChartData();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      PluginManager.plugins.forEach(function (plugin) {
        var timelineModule = plugin.modules[ModuleTypeEnum.TimelineModule];

        if (timelineModule && typeof timelineModule.getData === 'function') {
          return _this2.timelineModules.push(timelineModule);
        }

        if (Array.isArray(timelineModule) && timelineModule.length) {
          var _this2$timelineModule;

          var validModules = timelineModule.filter(function (m) {
            return typeof m.getData === 'function' || Array.isArray(m.children) && m.children.every(function (c) {
              return c.name && typeof c.getData === 'function';
            });
          });
          return (_this2$timelineModule = _this2.timelineModules).push.apply(_this2$timelineModule, _toConsumableArray(validModules));
        }

        if (timelineModule) {
          logger.warn('Invalid Timeline Module', timelineModule.name);
        }
      }); // Activate all on load

      this.setState({
        activeDataNames: this.timelineModules.map(function (m) {
          return m.name;
        })
      });
    }
  }, {
    key: "filterVisibleDatasets",
    value: function filterVisibleDatasets(chartData) {
      var activeDataNames = this.state.activeDataNames;
      var activeTimelineModules = this.timelineModules.filter(function (m) {
        return activeDataNames.includes(m.name);
      });
      return chartData.datasets.filter(function (ds) {
        return activeDataNames.includes(ds.label) || activeTimelineModules.some(function (m) {
          return m.children && m.children.some(function (c) {
            return c.name === ds.label;
          });
        });
      });
    }
  }, {
    key: "changeTimelineModule",
    value: function changeTimelineModule(e) {
      var _this$state = this.state,
          chart = _this$state.chart,
          activeDataNames = _this$state.activeDataNames,
          chartData = _this$state.chartData;
      var element = e.currentTarget;
      var id = element.id;
      var isActive = element.classList.contains('active');

      if (isActive) {
        var index = activeDataNames.indexOf(id);
        activeDataNames.splice(index, 1);
      } else {
        // Add to active plugins
        activeDataNames.push(id);
      }

      this.setState({
        activeDataNames: activeDataNames
      });
      chart.data.datasets = this.filterVisibleDatasets(chartData);
      chart.update();
    }
  }, {
    key: "getButtonStyle",
    value: function getButtonStyle(name) {
      if (this.state.completedPlugins.includes(name) < 0) {
        return 'disabled';
      }

      if (this.state.activeDataNames.includes(name)) {
        return 'active';
      }
    }
  }, {
    key: "getDataButtons",
    value: function getDataButtons() {
      var _this3 = this;

      return this.timelineModules.map(function (module, index) {
        var completed = _this3.state.completedPlugins.includes(module.name);

        return /*#__PURE__*/React.createElement(Grid, {
          key: index,
          item: true,
          style: {
            width: '80px'
          }
        }, /*#__PURE__*/React.createElement(Link, {
          id: module.name,
          onClick: function onClick(e) {
            return _this3.changeTimelineModule(e);
          },
          className: _this3.getButtonStyle(module.name)
        }, /*#__PURE__*/React.createElement("div", {
          style: {
            width: '32px',
            height: '32px'
          }
        }, completed ? getIcon(module.icon, 32, _this3.getDataButtonColor(module.name)) : /*#__PURE__*/React.createElement(CircularProgress, {
          color: "primary",
          size: 32
        })), /*#__PURE__*/React.createElement(Typography, {
          className: "plugin-name",
          align: "center",
          style: {
            color: _this3.getDataButtonColor(module.name),
            marginTop: '5px'
          }
        }, module.name)));
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Typography, {
        variant: "h3",
        color: "primary",
        style: {
          margin: '5px 15px 0 30px'
        }
      }, t('ehr', 'Timeline'))), /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Box, {
        mt: 1,
        style: {
          position: 'relative'
        }
      }, /*#__PURE__*/React.createElement(Box, {
        ref: this.chartBoxRef,
        m: 4
      }, /*#__PURE__*/React.createElement("canvas", {
        ref: this.chartRef
      })), !this.state.completedPlugins.length && /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'absolute',
          top: '30px',
          left: 'calc(50% - 10px)'
        }
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "h3",
        color: "primary"
      }, /*#__PURE__*/React.createElement(CircularProgress, {
        size: 48,
        color: "primary"
      })))), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Box, {
        ml: 4,
        mr: 4,
        mt: 2,
        mb: 2
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        direction: "row",
        spacing: 2,
        alignItems: "center"
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 8
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true
      }, this.getDataButtons())), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 4,
        style: {
          textAlign: 'right'
        }
      }, /*#__PURE__*/React.createElement(TimeRangeFilter, {
        handleDateRangeChange: this.handleDateRangeChange
      })))))));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return Timeline;
}(Component);

var _default = withMain(Timeline);

export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(logger, "logger", "/home/runner/html/nextcloud/apps/ehr/js/platform/main/src/components/Timeline/Timeline.js");
  reactHotLoader.register(Link, "Link", "/home/runner/html/nextcloud/apps/ehr/js/platform/main/src/components/Timeline/Timeline.js");
  reactHotLoader.register(Timeline, "Timeline", "/home/runner/html/nextcloud/apps/ehr/js/platform/main/src/components/Timeline/Timeline.js");
  reactHotLoader.register(_default, "default", "/home/runner/html/nextcloud/apps/ehr/js/platform/main/src/components/Timeline/Timeline.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();